export * from './FlagBIcon';
export * from './FlagBIcon16Light';
export * from './FlagBIcon16Regular';
export * from './FlagBIcon16Solid';
export * from './FlagBIcon20Light';
export * from './FlagBIcon20Regular';
export * from './FlagBIcon20Solid';
export * from './FlagBIcon24Regular';
export * from './FlagBIcon24Solid';
export * from './FlagBIcon32Regular';
export * from './FlagBIcon64Regular';
